{
  "title": "Clientes",
  "description": "Personas que han reservado citas con su negocio.",
  "searchPlaceholder": "Buscar clientes...",
  "columns": {
    "phone": "Teléfono",
    "verified": "Verificado",
    "joined": "Registro"
  },
  "show": {
    "notFound": "Cliente no encontrado.",
    "back": "Volver a clientes",
    "unnamed": "Cliente sin nombre",
    "verified": "Verificado",
    "unverified": "No verificado",
    "phone": "Teléfono",
    "email": "Correo electrónico",
    "joined": "Registro",
    "appointmentsTitle": "Citas",
    "emptyAppointmentsTitle": "Aún no hay citas",
    "emptyAppointmentsDescription": "Este cliente no ha reservado ninguna cita con su negocio."
  }
}
